/**
 * Bo'lim sarlavhasi: bir ustunda mavzuli 3D model, ikkinchisida nom, qisqa
 * izoh va amallar (tugma, havola, tablar). Barcha sahifalarda bir xil:
 * matn chapda, model o'ngda; sarlavha alohida rangli «tasma»da turadi. Sahnalar o'chiq bo'lsa
 * (telefon, yuqori kontrast, WebGL yo'q) faqat matn ustuni qoladi.
 */
import { createContext, useContext } from "react";
import type { ReactNode } from "react";

import { SceneCell } from "./scenes3d/SectionScenes";

/**
 * Alohida bo'lim sahifalarida (`SectionPage` ichida) sarlavha «tasma»si ko'rsatilmaydi:
 * sahifa to'g'ridan-to'g'ri mazmundan boshlanadi. Sarlavha ekran o'qish dasturlari uchun
 * ko'rinmas holda qoladi, tugma/havola kabi amallar esa (`children`) saqlanadi.
 */
export const BareHeadContext = createContext(false);

export function SplitHead({
  scene,
  eyebrow,
  title,
  titleId,
  lead,
  children,
}: {
  scene: string;
  /** Eski chaqiruvlar bilan moslik: barcha sahifalarda model o'ngda, matn chapda. */
  side?: "left" | "right";
  eyebrow?: ReactNode;
  title: ReactNode;
  titleId?: string;
  lead?: ReactNode;
  children?: ReactNode;
}) {
  const bare = useContext(BareHeadContext);
  if (bare) {
    return (
      <div className="bare-head">
        {eyebrow && typeof eyebrow !== "string" ? <span className="eyebrow">{eyebrow}</span> : null}
        <h2 id={titleId} className="visually-hidden">
          {title}
        </h2>
        {children ? <div className="split-actions">{children}</div> : null}
      </div>
    );
  }
  return (
    <div className="section-head split-head model-right" data-reveal>
      <SceneCell name={scene} />
      <div className="split-copy">
        {eyebrow ? <span className="eyebrow">{eyebrow}</span> : null}
        <h2 id={titleId}>{title}</h2>
        {lead ? <p className="section-lead">{lead}</p> : null}
        {children ? <div className="split-actions">{children}</div> : null}
      </div>
    </div>
  );
}
